import React from 'react';
import { Employee } from '../utils/AccountsAPI';
import { GenericAutocomplete, IGenericAutocomplete } from './GenericAutocomplete';

interface IUserAutocomplete<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
> extends IGenericAutocomplete<Employee, Multiple, DisableClearable, FreeSolo> {
  label?: string;
  TextFieldProps?: any;
}

export function UserAutocomplete<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>(props: IUserAutocomplete<Multiple, DisableClearable, FreeSolo>) {
  return (
    <GenericAutocomplete
      autoHighlight
      autoComplete
      idField='id'
      filterFields={['userName', 'fullName', 'employeeNumber']}
      titleField='userName'
      labelField='userName'
      contentField='fullName'
      {...props}
    />
  );
}
